
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  
  if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
    Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
  }
  Flits(document).on('Flits:wishlistButton:Loaded', function(event){
    if (Flits.request.page_type == 'index' || Flits.request.page_type == 'product') {
      let collectionBtn = Flits('.flits-wishlist-colection');
      parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
        Flits(collectionBtn).show(),
        Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
    }
  });

  
//    function se_main() {
     
//   if (typeof Searchanise != 'undefined') {
//     setTimeout(se_main, 100);
//   }

//   var jq = Searchanise;
// //      console.log(jq);
//     $(document).on('Searchanise.ResultsUpdated',function(event,results){
// //       debugger;
//       console.log("FLITS",event,results);
//       var ul = $(results).find('.snize-search-results-content');
//       console.log(ul);
//       $(ul).find('li.snize-product').each(function(index,li_item){
//         var title,handle,image,id,pathname;
//         var html_structure = Flits('.flits-wishlist-collection-page-template').clone(true).find('.flits-wishlist-colection');

//         title = $(li_item).find('.snize-title').text();
//         pathname = $(li_item).find('.snize-view-link')[0].pathname;
//         handle = pathname.split('/')[pathname.split('/').length - 1];
//         image = $(li_item).find('.snize-thumbnail img:first-child').attr('src');
//         id = Flits(li_item).attr('id').replace('snize-product-','');

//         html_structure.find('.flits-wls-button').attr({
//           'data-flits-product-id':id,
//           'data-flits-product-title':title,
//           'data-flits-product-handle':handle,
//           'data-flits-product-image':image,
//         });


//         if(Flits.isProductAddedInWishlist(li_item.handle)){ 
//           html_structure.find('.flits-wls-button').removeClass("flits-wls-inactive");
//           html_structure.find('.flits-wls-button').addClass("flits-wls-active");
//           html_structure.find('.flits-wls-button').attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.add_to_wishlist_button', 'Add to Wishlist'))
//         } 
// //         console.log("3");
// //         console.log(id);
// //         console.log(title);console.log(handle);
// //         console.log(li_item);
//         $(li_item).append(html_structure);
//       });
//     });
//    }

// // setTimeout(se_main, 100);
//   se_main();
  
  
  
  $(document).on('Searchanise.ResultsUpdated',function(event,results){
	console.log("FLITS",event,results);
  	var ul = $(results).find('.snize-search-results-content');
  $(ul).find('li.snize-product').each(function(index,li_item){
  		var title,handle,image,id,pathname;
    	var html_structure = $('.flits-wishlist-collection-page-template').clone(true).find('.flits-wishlist-colection');
    	
    	title = $(li_item).find('.snize-title').text();
    	pathname = $(li_item).find('.snize-view-link')[0].pathname;
    	handle = pathname.split('/')[pathname.split('/').length - 1];
    	image = $(li_item).find('.snize-thumbnail img:first-child').attr('src');
    	id = $(li_item).attr('id').replace('snize-product-','');
		
        html_structure.find('.flits-wls-button').attr({
          'data-flits-product-id':id,
          'data-flits-product-title':title,
          'data-flits-product-handle':handle,
          'data-flits-product-image':image,
        });
              console.log("handle");

          console.log(handle);
          var isWishlisted = window.Flits.isProductAddedInWishlist(handle);
    
              console.log(isWishlisted);

    	 if(isWishlisted){ 
          html_structure.find('.flits-wls-button').removeClass("flits-wls-inactive");
          html_structure.find('.flits-wls-button').addClass("flits-wls-active");
          html_structure.find('.flits-wls-button').attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.add_to_wishlist_button', 'Add to Wishlist'))
        } 
    	$(li_item).append(html_structure);
  });
  });
  
}(Flits));


 